module.exports = __webpack_public_path__ + "img/ss_pink-06.db765e3e.jpg";